import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import type { ChatHistoryVisibility } from '../lib/types';

interface ViewerControlsProps {
  allowRearrange?: boolean;
  onRearrange?: () => void;
  chatVisibility?: ChatHistoryVisibility;
}

export const ViewerControls: React.FC<ViewerControlsProps> = ({
  allowRearrange = true,
  onRearrange,
  chatVisibility = 'authenticated',
}) => {
  const { user, logout } = useAuth();

  const showChatButton = (() => {
    if (chatVisibility === 'hidden') return false;
    if (chatVisibility === 'admin_only') return user?.role === 'admin';
    if (chatVisibility === 'public') return true;
    return Boolean(user);
  })();

  return (
    <nav className="viewer-controls" aria-label="Viewer controls">
      <div className="viewer-controls-inner">
        {user?.role === 'admin' && (
          <Link to="/admin" className="control-btn" title="Go to Dashboard">
            Dashboard
          </Link>
        )}

        {allowRearrange && onRearrange && (
          <button
            type="button"
            className="control-btn"
            onClick={onRearrange}
            aria-label="Generate a new arrangement"
          >
            New arrangement
          </button>
        )}

        {showChatButton && (
          <Link
            to="/chat"
            className="control-btn"
            title="View chronological chat history"
            aria-label="View chronological chat history"
          >
            Chat history
          </Link>
        )}

        <button
          type="button"
          className="control-btn control-btn-logout"
          onClick={() => logout()}
          aria-label="Log out of keepsake"
        >
          Sign out
        </button>
      </div>
    </nav>
  );
};
